module.exports = __webpack_public_path__ + "img/serre-toi-hero-banner.b4b2015c.jpg";